import _getIterator from 'babel-runtime/core-js/get-iterator';
import moment from 'moment';
import * as datetime from './datetime';

export var getListTotalDuration = function getListTotalDuration(list) {
  var total = 0;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var element = _step.value;

      if (!element || element.free) {
        continue;
      }
      total += element.estimatedTime;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return total;
};

export var buildDragAndDropUpdateBody = function buildDragAndDropUpdateBody(table, index, list) {
  var todoItem = list[index];
  /* if todoItem not found (drag & drop bug), take the last element of the list */
  if (!todoItem) {
    index = list.length - 1;
    todoItem = list[index];
  }
  if (!todoItem || !todoItem.id) {
    return null;
  }
  var res = {};
  res.taskId = todoItem.id;
  var todoItemBefore = list[index - 1];
  var todoItemAfter = list[index + 1];
  if (datetime.isGroupUpcoming(table)) {
    res.group = table;
  } else if (table === 'today') {
    res.date = moment().format('YYYY-MM-DD');
  } else if (table === 'tomorrow') {
    res.date = moment().add(1, 'days').startOf('day').format('YYYY-MM-DD');
  } else {
    res.date = '';
  }
  if (todoItemBefore && !(todoItemBefore.type === 'event' && !!todoItemBefore.pin && !!todoItemBefore.pin.date)) {
    res.todoItemDetailsBefore = {
      id: todoItemBefore.id,
      type: todoItemBefore.type
    };
  }
  if (todoItemAfter && !(todoItemAfter.type === 'event' && !!todoItemAfter.pin && !!todoItemAfter.pin.date)) {
    res.todoItemDetailsAfter = {
      id: todoItemAfter.id,
      type: todoItemAfter.type
    };
  }
  return res;
};
//# sourceMappingURL=list.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/list.js
// module id = 756
// module chunks = 0